import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getRates, saveRatesBatch } from '../../api/rates';
import type { Rate } from '../../types/Rate';
import { t } from '../../i18n/t';

// "שערי ניירות" — current-snapshot rate data per asset (Central).
// Natural PK assetId — editable only on Add. All rate fields nullable (some
// catalog rows are placeholders for assets that don't yet have data).
const columnDefs: ColDef<Rate>[] = [
  {
    field: 'assetId',
    headerName: t('rates.columns.assetId'),
    width: 130,
    editable: (params: EditableCallbackParams<Rate>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'baseRate',
    headerName: t('rates.columns.baseRate'),
    width: 140,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'currRate',
    headerName: t('rates.columns.currRate'),
    width: 140,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'nav',
    headerName: t('rates.columns.nav'),
    width: 140,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'value1Point',
    headerName: t('rates.columns.value1Point'),
    width: 140,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'sourceId',
    headerName: t('rates.columns.sourceId'),
    width: 110,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'navDate',
    headerName: t('rates.columns.navDate'),
    width: 160,
    editable: true,
  },
  // V1.71.4 — Black-Scholes inputs.
  {
    field: 'ivBaseAsset',
    headerName: t('rates.columns.ivBaseAsset'),
    width: 130,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'ribitOptions',
    headerName: t('rates.columns.ribitOptions'),
    width: 130,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'kofelBaseRate',
    headerName: t('rates.columns.kofelBaseRate'),
    width: 130,
    editable: true,
    cellDataType: 'number',
  },
];

const newRateDefaults = (): Partial<Rate> => ({
  assetId: 0,
  baseRate: null,
  sourceId: null,
  nav: null,
  value1Point: null,
  navDate: null,
  currRate: null,
  ivBaseAsset: null,
  ribitOptions: null,
  kofelBaseRate: null,
});

export function RatesPage() {
  return (
    <LopCrudPage<Rate>
      resourceCode="rates"
      titleKey="rates.pageTitle"
      idField="assetId"
      getRows={getRates}
      saveBatch={(added, modified, deletedIds) =>
        saveRatesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRateDefaults}
    />
  );
}
